import { Alert, Skeleton } from "@mui/material";

export default function AlertMessage({
  condition,
  warningMessage,
  successMessage,
  isLoading,
}) {
  const severity = condition ? "warning" : "success";
  const message = condition ? warningMessage : successMessage;

  if (isLoading) {
    return (
      <Skeleton
        variant="rectangular"
        height={50}
        sx={{ my: 2, borderRadius: 1 }}
      />
    );
  }

  return (
    <Alert severity={severity} sx={{ my: 2 }}>
      {message}
    </Alert>
  );
}
